import { Component, type ErrorInfo, type ReactNode } from "react";

interface Etat {
  erreur: Error | null;
}

/**
 * Barrière d'erreur.
 *
 * Sans elle, une seule exception au rendu démonte tout l'arbre React et
 * laisse un écran blanc, sans le moindre indice. Ici l'incident reste
 * circonscrit à la page, il est nommé, et la navigation demeure utilisable.
 */
export class Barriere extends Component<{ children: ReactNode }, Etat> {
  state: Etat = { erreur: null };

  static getDerivedStateFromError(erreur: Error): Etat {
    return { erreur };
  }

  componentDidCatch(erreur: Error, infos: ErrorInfo) {
    // La console reste la source détaillée pour le diagnostic technique.
    console.error("Erreur de rendu :", erreur, infos.componentStack);
  }

  private reessayer = () => this.setState({ erreur: null });

  render() {
    const { erreur } = this.state;
    if (erreur == null) return this.props.children;

    return (
      <div className="message erreur">
        <strong>Cette page n'a pas pu s'afficher.</strong>
        <p style={{ margin: "8px 0" }}>{erreur.message}</p>
        <p className="discret-texte" style={{ margin: "0 0 10px" }}>
          Les données ne sont pas perdues : seul l'affichage a échoué. Le détail
          technique figure dans la console du navigateur.
        </p>
        <button onClick={this.reessayer}>Réessayer</button>
      </div>
    );
  }
}
